module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "customerSetupScreen",
    attrs: {
      "fluid": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md5": "",
      "lg4": ""
    }
  }, [_c('div', {
    staticClass: "customerSetupPanel"
  }, [_c('img', {
    staticClass: "customerSetupLogo",
    attrs: {
      "src": require("../shared/assets/images/logo_new.png"),
      "alt": "MyOrder"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Customer Support")]), _vm._v(" "), _c('p', [_vm._v("The Myorder portal is not currently set up for customer support. Don't worry, though—all of your tools and functionality are fully available to you right now in the app.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "customerSetupLogout",
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.fncLogout
    }
  }, [_vm._v("Logout")])], 1)])], 1)], 1)
},staticRenderFns: []}